import { LocationState } from 'src/sensors/LocationState.ts';

export type LocationStateContextType = {
    locationState: LocationState;
    setLocationState: (state: LocationState) => void;
}

export const initLocationState: LocationState = {
    sensorLabel: '',
    sensorsPage: '1',
    selectedAccessories: [],
    isImperial: null,
    qty: 1,
    sent: false,
    selectedFlowRange: 'FlowRangeM3h',
    checkoutComment: '',
    pipeConnectors: false,
};

export const isLocationState = (arg: unknown): arg is LocationState => typeof arg === 'object' &&
    arg !== null && 'selectedAccessories' in arg && arg.selectedAccessories !== undefined;
